export default __webpack_public_path__ + "static/media/MAINTENANCE IN CRIMINAL LAW WITH SPECIFIC REFERNCE TO LIVE -IN -RELAIONSHIP - Aditi Singh.116c7e0d.pdf";